import HttpError from '../utilities/HttpError.js';
import fetch from '../globalWrappers/fetch.js';
import breakPromise from './breakPromise.js';
import redirectToLogin from './redirectToLogin.js';

async function fetchHelper({
  accept,
  body,
  contentType,
  headers,
  method,
  url,
  language = 'en_US',
}) {
  let options = {
    credentials: 'include',
    body: body,
    headers: {
      'Accept': accept || 'application/json',
      'Content-Type': contentType,
      'Cache': 'no-cache',
      ...headers
    },
    method: method,
  };
  let response;

  try {
    response = await fetch(url, options);
  } catch (e) {
    throw new Error('Network Error');
  }

  let responseBody = await parseBody(response);

  if (response.status === 401) {
    redirectToLogin(language);
    return breakPromise();
  }

  if (!response.ok) {
    throw new HttpError(response.status, responseBody, getCorrelationId(response));
  }

  return responseBody;
}

function getCorrelationId(response) {
  const headerName = 'X-CO-Correlation-Id';
  if (response.headers.has(headerName)) {
    return response.headers.get(headerName);
  }
}

async function parseBody(response) {
  if (!response.headers.has('Content-Type') || !response.headers.get('Content-Type').startsWith('application/json')) {
    return await response.text();
  }

  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}

export default fetchHelper;
